export interface AppConfig {
  autoAccept: boolean;
  bufferCall: boolean;
}

export const config: AppConfig = {
  autoAccept: false,
  bufferCall: false
};
